module.exports = new __parcel__URL__("ww-animated-core-elements.be26231c.gif").toString();